export type Period = "7d" | "30d" | "90d" | "custom";

/**
 * ローカルタイムゾーンの日付を 'YYYY-MM-DD' にする。
 * `Date#toISOString()` はUTCに変換してから切り出すため、JST 0-9時台は「前日」の日付になる
 * バグがあった（UTC+9のJSTでは、その時間帯はまだUTC側で前日）。年月日はローカルの
 * getFullYear/getMonth/getDateから直接組み立てる（タイムゾーン変換を経由しない）。
 */
export function toLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * JST（Asia/Tokyo）の「今日」を 'YYYY-MM-DD' で返す。閲覧者のブラウザTZに関係なく
 * サーバー（stoq-worker）と同じ基準日になる（P/Lダッシュボードの基準日はJST固定・review §4-1）。
 */
export function jstTodayYmd(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Tokyo" }).format(new Date());
}

/** 期間切替の from/to を今日基準で計算する。customはUIで指定された値をそのまま使う。 */
export function resolveRange(
  period: Period,
  custom: { start: string; end: string }
): { from: string; to: string } {
  if (period === "custom") {
    return { from: custom.start, to: custom.end };
  }
  const days = period === "7d" ? 7 : period === "90d" ? 90 : 30;
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - (days - 1));
  return { from: toLocalYmd(start), to: toLocalYmd(end) };
}
